(function(){
  var form = document.getElementById('lcForm');
  if(!form) return;
  var COMPANY = form.dataset.company || '';
  var LIST    = form.dataset.list || '';
  var REV     = '2026-07-15';

  var field = document.getElementById('lcEmail');
  var btn   = document.getElementById('lcBtn');
  var err   = document.getElementById('lcErr');
  var done  = document.getElementById('lcDone');
  var hp    = form.querySelector('input[name="apellido2"]');
  var busy  = false;
  var LABEL = btn.textContent;

  function valid(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  function fail(msg){
    err.textContent = msg;
    field.setAttribute('aria-invalid','true');
    field.focus();
  }

  function props(){
    var q = new URLSearchParams(window.location.search);
    var out = { 'Origen': 'Landing YouTube' };
    var keys = ['v','mix','utm_source','utm_medium','utm_campaign','utm_content'];
    for (var i=0;i<keys.length;i++){
      var val = q.get(keys[i]);
      if (val) out[keys[i] === 'v' ? 'video' : keys[i]] = String(val).slice(0,120);
    }
    return out;
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    if (busy) return;
    if (hp && hp.value) return;

    var email = field.value.trim();
    err.textContent = '';
    field.removeAttribute('aria-invalid');

    if (!valid(email)) { fail('Ese correo no se ve bien. Revisalo.'); return; }
    if (!COMPANY || !LIST) { fail('Falta configurar la lista.'); return; }

    busy = true;
    btn.disabled = true;
    btn.textContent = 'Mandando...';

    var body = { data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: {
      email: email,
      properties: props(),
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    } } } }, relationships: { list: { data: { type: 'list', id: LIST } } } } };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REV },
      body: JSON.stringify(body)
    })
    .then(function(res){
      if (res.status === 202 || res.ok) {
        form.classList.add('is-off');
        done.classList.add('is-on');
      } else { throw new Error('status ' + res.status); }
    })
    .catch(function(){
      busy = false;
      btn.disabled = false;
      btn.textContent = LABEL;
      fail('No se pudo mandar. Intenta otra vez en un momento.');
    });
  });
})();
